import { render } from "./NailPanelTestSelection.vue?vue&type=template&id=23d12184"
import script from "./NailPanelTestSelection.vue?vue&type=script&lang=js"
export * from "./NailPanelTestSelection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/testSelection/NailPanelTestSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23d12184"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23d12184', __exports__)) {
    console.log('reload')
    api.reload('23d12184', __exports__)
  }
  
  module.hot.accept("./NailPanelTestSelection.vue?vue&type=template&id=23d12184", () => {
    console.log('re-render')
    api.rerender('23d12184', render)
  })

}


export default __exports__